import { Button, Text } from "./InsertIp.styled";

export const InsertIp = ({ text, handleIp }) => (
  <Button onClick={handleIp} type={"button"}>
    <Text>{text}</Text>
  </Button>
);
